import { Menu, Tooltip } from 'antd'
import BreadCrumb from 'components/BreadCrumb'
import Button from 'components/Button'
import Drawer from 'components/Drawer'
import Export from 'components/Export'
import LeftArrow from 'components/icons/LeftArrow'
import CsvImage from 'components/icons/csv-image.svg'
import GoogleSheetImage from 'components/icons/google-sheet.svg'
import XlsxImage from 'components/icons/xlsx-image.svg'
import PreviewDrawer from 'modules/Events/Preview/Partials/Drawer/PreviewDrawer'
import { FooterFlex } from 'modules/Students/Partials/StudentsBulkUpload/Style/style'
import moment from 'moment'
import { Fragment, default as React, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import ExportTransfer from '../../../components/ExportTransfer'
import { dateConversion } from '../../../utils/rolecreationHelpers'
import ResolveConflict from '../../ATS/Components/ResolveConflict'
import {
  CandidatesSpan,
  ConflictName,
  Minus,
  SectionName,
  ShortList,
  StyledTab,
  TextEllipse,
} from '../../ATS/style'
import { JobRoleFlex, LeftSection, PlacementFlex } from '../../Placement/style'
import EventUpload from './EventUpload'
import Table from './Table'
import {
  BreadLastData,
  CustomDiv,
  CustomizeMenu,
  CustomSpin,
  LeftBread,
  RightSideDiv,
} from './style'

const EventRole = ({
  getEventByEventIDSwitch,
  bulkUploadForEvents,
  resolveConflict,
  getEventId,
  getEventByEventID,
  getExportFiledData,
  instituteCampusId,
  exportEventCandidate,
  getStatusUpdateBulk,
  getPreview,
}) => {
  const [currentTab, setCurrentTab] = useState('ACTIVE')
  const [uploadDrawer, setUploadDrawer] = useState(false)
  const [conflictStatus, setConflictStatus] = useState('')
  const [fileLoading, setFileLoading] = useState(false)
  const [progress, setProgress] = useState(10)
  const [finalUpload, setFinalUpload] = useState(0)
  const [conflictDrawer, setConflictDrawer] = useState(false)
  const params = useParams()
  const [tableData, setTableData] = useState({})
  const [pageNumber, setPageNumber] = useState(0)
  const [tableLoader, setTableLoader] = useState(false)
  const [searchValue, setSearchValue] = useState('')
  const [sorter, setSorter] = useState('')

  const [selectedKeys, setSelectedKeys] = useState([])
  const [targetKeys, setTargetKeys] = useState([])
  const [transfer, setTransfer] = useState(false)
  const [exportType, setExportType] = useState('')
  const [data, setData] = useState([])
  const [isDrawerVisible, setIsDrawerVisible] = useState(false)

  const [exportLoading, setExportLoading] = useState(false)
  const [isAllSelected, setIsAllSelected] = useState(false)
  const [wholeSelect, setWholeSelect] = useState(false)
  const [exportOpen, setExportOpen] = useState(false)

  const columns = [
    {
      dataIndex: 'title',
      title: 'Name',
    },
  ]

  const handleDrawerClose = () => {
    setIsDrawerVisible(!isDrawerVisible) // Set drawer visibility to false on close
  }

  const handleTransferClick = async isOpen => {
    try {
      if (isOpen) {
        // let fieldDatas = roleExportKeys
        let fieldDatas = await getExportFiledData()
        fieldDatas = fieldDatas.map((item, index) => {
          return {
            key: index,
            title: item,
          }
        })
        setData(fieldDatas)
      } else {
        setData([])
      }
      setSelectedKeys([])
      setExportType('')
      setTargetKeys([])
      setTransfer(isOpen)
    } catch (error) {
      //console.log(error)
    }
  }

  const handleExportType = value => {
    if (exportType == value) {
      setExportType('')
    } else {
      setExportType(value)
    }
  }

  const handleExportClick = async value => {
    setExportLoading(true)

    try {
      let payload = {
        downloadList: selectedKeys.map(item => item.title),
      }
      let title = getEventId?.title
      const displayname =
        currentTab === 'REGISTER'
          ? `Registered Student`
          : currentTab === 'UNREGISTER'
          ? `Not Registered Student`
          : `Invited Student`

      if (value === 'xlsx') {
        try {
          //export
          const blob = await exportEventCandidate(
            params.eventId,
            value,
            payload,
            title,
            currentTab
          )
          const url = window.URL.createObjectURL(new Blob([blob]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute(
            'download',
            `${getEventId?.title + ' - ' + displayname + '.xlsx'}`
          )
          document.body.appendChild(link)
          link.click()
          link.parentNode.removeChild(link)
          setExportLoading(false)
          handleTransferClick(false)
        } catch (error) {
          setExportLoading(false)
          ErrorMessage(error)
        }
      } else if (value === 'googlesheet') {
        try {
          const response = await exportEventCandidate(
            params.eventId,
            value,
            payload,
            title,
            currentTab
          )
          window.open(response?.data?.url, '_blank')
          setExportLoading(false)
          handleTransferClick(false)
        } catch (error) {
          setExportLoading(false)
          ErrorMessage(error)
        }
      } else {
        try {
          const blob = await exportEventCandidate(
            params.eventId,
            value,
            payload,
            title,
            currentTab
          )
          const url = window.URL.createObjectURL(
            new Blob([blob], { type: 'text/csv' })
          )
          const link = document.createElement('a')
          link.href = url
          link.setAttribute(
            'download',
            `${getEventId?.title + ' - ' + displayname + '.csv'}`
          )

          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          handleTransferClick(false)

          setExportLoading(false)
        } catch (error) {
          setExportLoading(false)
          ErrorMessage(error)
        }
      }
    } catch (error) {
      ErrorMessage(error)
    }
  }
  const navigate = useNavigate()
  const [selectedCandidateId, setSelectedCandidateId] = useState([])
  const [selectedCandidate, setSelectedCandidate] = useState([])
  const [file, setFile] = useState('')
  const [bulkUploadResult, setBulkUploadResult] = useState({})
  const [failed, setFailed] = useState(false)
  const [bulkUploadError, setBulkUploadError] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [conflictData, setConflictData] = useState([])
  const [conflictFilter, setConflictFilter] = useState({
    search: '',
    page: 0,
  })
  const [isPaid, setIsPaid] = useState(false)
  const [debouncedSearch, setDebouncedSearch] = useState(
    () => conflictFilter.search
  )
  const { TabPane } = StyledTab

  const breadCrumbData = [
    {
      title: 'Event',
      name: 'Event',
      navigate: `/events`,
      active: false,
    },
    {
      title: getEventId?.title,
      name: getEventId?.title,
      active: true,
    },
  ]

  const TabList = [
    {
      tabName: 'Invited',
      count: tableData?.activecounts,
      key: 'ACTIVE',
    },
    ...(getEventId?.isRegister === true
      ? [
          {
            tabName: 'Registered',
            count: tableData?.Registeredcounts,
            key: 'REGISTER',
          },
          {
            tabName: 'Not Registered',
            count: tableData?.notRegisteredcounts,
            key: 'UNREGISTER',
          },
        ]
      : []),
  ]

  const handleTabChange = key => {
    setCurrentTab(key)
    setPageNumber(0)
    setIsPaid(false)
    handleClear()
    callStudentList({ current: key, pageNum: 0 })
  }

  useEffect(() => {
    callStudentList({ pageNum: 0, paid: isPaid })
  }, [isPaid])

  const handleResolveConflict = () => {
    setConflictDrawer(true)
    getConflict()
    setFile('')
    setUploadDrawer(false)
  }

  const handleBulkUpload = () => {
    setUploadDrawer(true)
  }

  const handleUploadClick = value => {
    setConflictStatus(value)
  }
  const handleFileUpload = async fileUrl => {
    try {
      if (fileUrl) {
        setFileLoading(true)
        setBulkUploadResult({})
        let payLoad = {
          fileUrl,
          isPaid: 'paid',
        }
        if (!failed) {
          const interval = setInterval(() => {
            setProgress(prevProgress => {
              const nextProgress = prevProgress + 10
              if (nextProgress >= 100) {
                clearInterval(interval)
                return 100
              }
              return nextProgress
            })
          }, 1000)
        }
        const result = await bulkUploadForEvents(payLoad, params?.eventId)
        setProgress(100)
        callStudentList({})
        setFailed(false)
        setBulkUploadResult(result?.data)
        setFileLoading(false)
      }
    } catch (error) {
      //console.log(error)
      setProgress(100)
      setFailed(true)
      setBulkUploadError(error?.response?.data?.message)
      ErrorMessage(error?.response?.data?.message)
      setFileLoading(false)
    }
  }

  const UploadedData = [
    {
      name: 'Upload Paid Students',
      content: 'Upload result in Excel sheet',
      status: 'RELEASED',
    },
  ]

  const uploaderContent = () => {
    return (
      <EventUpload
        handleUploadClick={handleUploadClick}
        conflictStatus={conflictStatus}
        handleFileUpload={handleFileUpload}
        setFileLoading={setFileLoading}
        fileLoading={fileLoading}
        UploadedData={UploadedData}
        progress={progress}
        finalUpload={finalUpload}
        setFinalUpload={setFinalUpload}
        setFile={setFile}
        file={file}
        setFailed={setFailed}
        failed={failed}
        bulkUploadResult={bulkUploadResult}
        handleResolveConflict={handleResolveConflict}
        bulkUploadError={bulkUploadError}
      />
    )
  }

  const getConflict = async () => {
    try {
      setIsLoading(true)
      const getConflictData = await resolveConflict(
        params?.eventId,
        conflictFilter.page,
        conflictFilter.search
      )
      if (getConflictData?.result?.length === 0 && !conflictFilter.search) {
        setConflictDrawer(false)
      }
      setIsLoading(false)
      setConflictData(getConflictData)
    } catch (error) {
      ErrorMessage(error)
      setIsLoading(false)
    }
  }

  useEffect(() => {
    getConflict()
  }, [conflictFilter.page, debouncedSearch, uploadDrawer])

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedSearch(conflictFilter.search)
      setConflictFilter({ ...conflictFilter, page: 0 })
    }, 1000)
    return () => {
      clearTimeout(timeout)
    }
  }, [conflictFilter.search])

  const ConflictColumn = [
    {
      width: 140,
      title: 'Uploaded Data',
      dataIndex: 'Uploaded Data',
      key: 'Uploaded Data',
      className: 'uploaded-data',
      render: (text, record) => {
        const { primaryEmail, lastName, firstName, mobile } =
          record.uploadedCandidateData
        const disable = record.candidateDetails.every(
          item =>
            item.primaryEmail?.toLowerCase()?.trim() ===
            primaryEmail?.toLowerCase()?.trim()
        )
        const nameDisable = record.candidateDetails.every(
          item =>
            item.student.firstName?.toLowerCase()?.trim() ===
            firstName?.toLowerCase()?.trim()
        )
        const lastDisable = record.candidateDetails.every(
          item =>
            item.student?.lastName?.toLowerCase()?.trim() ===
            lastName?.toLowerCase()?.trim()
        )
        const phoneDisable = record?.candidateDetails?.every(
          item => item?.phoneNumber?.trim() === mobile?.trim()
        )

        return (
          <Tooltip
            title={
              <div>
                {firstName}
                {lastName}
                <br />
                {mobile}
                <br />
                {primaryEmail}
              </div>
            }
          >
            <TextEllipse disable={nameDisable}>
              {firstName}{' '}
              <span
                style={{ color: lastDisable ? '#000' : 'rgb(227, 94, 80)' }}
              >
                {lastName}
              </span>
            </TextEllipse>

            <ConflictName disable={phoneDisable}>{mobile}</ConflictName>
            <ConflictName disable={disable}>
              {primaryEmail?.toLowerCase()}
            </ConflictName>
          </Tooltip>
        )
      },
      onCell: (record, index) => {
        const rowSpan =
          record.candidateDetails.length == 0
            ? 1
            : record.candidateDetailIndex === 0
            ? record.candidateDetails.length
            : 0
        return { rowSpan }
      },
    },
    {
      width: 140,
      title: 'Name',
      dataIndex: 'Name',
      key: 'Name',
      render: (text, record) => {
        const enableMinus = record.candidateDetail === null

        const { student } = record?.candidateDetail || {}
        const disable =
          record?.uploadedCandidateData?.firstName?.toLowerCase()?.trim() ===
          student?.firstName?.toLowerCase()?.trim()

        const lastDisable =
          record?.uploadedCandidateData?.lastName?.toLowerCase()?.trim() ===
          student?.lastName?.toLowerCase()?.trim()

        return (
          <>
            {enableMinus ? (
              <Minus>-</Minus>
            ) : (
              <Tooltip
                title={
                  <div>
                    {student.firstName?.toLowerCase()}{' '}
                    {student.lastName?.toLowerCase()}
                  </div>
                }
              >
                <ConflictName disable={disable}>
                  {student.firstName?.toLowerCase()}{' '}
                  <span
                    style={{ color: lastDisable ? '#000' : 'rgb(227, 94, 80)' }}
                  >
                    {student.lastName?.toLowerCase()}
                  </span>
                </ConflictName>
              </Tooltip>
            )}
          </>
        )
      },
    },
    {
      width: 140,
      title: 'Contact details',
      dataIndex: 'Contact details',
      key: 'Contact details',
      render: (text, record) => {
        const enableMinus = record.candidateDetail === null

        const { primaryEmail, secondaryEmail, phoneNumber } =
          record?.candidateDetail || {}
        const EmailDisable =
          primaryEmail?.toLowerCase()?.trim() ===
          record?.uploadedCandidateData?.email?.toLowerCase()?.trim()
        const secondaryEmailDisable =
          secondaryEmail?.toLowerCase()?.trim() ===
          record?.uploadedCandidateData?.email?.toLowerCase()?.trim()

        const phoneDisable =
          phoneNumber?.trim() === record?.uploadedCandidateData?.mobile?.trim()

        return (
          <>
            {enableMinus ? (
              <Minus>-</Minus>
            ) : (
              <Tooltip
                title={
                  <div>
                    {primaryEmail?.toLowerCase()}
                    <br />
                    {secondaryEmail?.toLowerCase()}
                    <br />
                    {phoneNumber}
                  </div>
                }
              >
                <ConflictName disable={EmailDisable}>
                  {primaryEmail?.toLowerCase()}
                </ConflictName>
                <ConflictName disable={secondaryEmailDisable}>
                  {secondaryEmail?.toLowerCase()}
                </ConflictName>
                <ConflictName disable={phoneDisable}>
                  {phoneNumber}
                </ConflictName>
              </Tooltip>
            )}
          </>
        )
      },
    },
    {
      width: 140,
      title: 'Degree & Department',
      dataIndex: 'Degree & Department',
      key: 'Degree & Department',
      render: (text, record) => {
        const enableMinus = record.candidateDetail === null

        const { degree, department } = record?.candidateDetail?.student || {}

        return (
          <>
            {enableMinus ? (
              <Minus>-</Minus>
            ) : (
              <Tooltip
                title={
                  <div>
                    {degree}
                    <br />
                    {department}
                  </div>
                }
              >
                <ConflictName disable={true}>
                  {degree?.toLowerCase()}
                </ConflictName>
                <ConflictName disable={true}>
                  {department?.toLowerCase()}
                </ConflictName>
              </Tooltip>
            )}
          </>
        )
      },
    },
    {
      width: 140,
      title: 'Status action',
      dataIndex: 'Status action',
      key: 'Status action',
      className: 'conflict-staus-action',
      render: (text, record) => {
        const disable = record.candidateDetail === null
        return (
          <ShortList
            disable={disable}
            onClick={() =>
              handlePaidBtn(record?.candidateDetail?.studentId, record?.id)
            }
          >
            Paid
          </ShortList>
        )
      },
    },
  ]

  const handlePaidBtn = async (value, id) => {
    try {
      let payLoad = {
        studentIds: value,
        isPaid: 1,
        forShowConflicts: true,
        conflictId: id,
        instituteCampusId: instituteCampusId,
      }
      await getStatusUpdateBulk(payLoad, params?.eventId)
      SuccessMessage('Success')
      getConflict()
      callStudentList({})
    } catch (error) {
      ErrorMessage(error)
    }
  }

  const conflictContent = () => {
    return (
      <ResolveConflict
        conflictData={conflictData || []}
        conflictFilter={conflictFilter}
        handlePageChange={handleConflictPageChange}
        handleSearch={handleConflictSearch}
        // handleShortListBtn={handleShortListBtn}
        isLoading={isLoading}
        columns={ConflictColumn}
      />
    )
  }
  const handleDrawerFooter = () => {
    return (
      <FooterFlex right>
        <Button.Secondary
          text="Close"
          onClick={() => {
            setFile('')
            setUploadDrawer(false)
          }}
        />
        {/* <Button.Primary
          htmlType="submit"
          form="bulkUpload"
          text="Save"
          disable={Object?.keys(bulkUploadResult)?.length === 0}
          onClick={() => setSuccessFull(true)}
        /> */}
      </FooterFlex>
    )
  }

  useEffect(() => {
    callStudentList({})
    handleEventCall()
  }, [])

  const handleEventCall = async () => {
    await getEventByEventID({ eventId: params?.eventId })
  }

  const callStudentList = async ({
    current = currentTab,
    pageNum = pageNumber,
    search = searchValue,
    sort = sorter,
    paid = isPaid,
  }) => {
    setTableLoader(true)
    try {
      setTableData([])
      setTableLoader(true)
      const eventId = params?.eventId
      const data = await getEventByEventIDSwitch({
        eventId,
        pageNum,
        current,
        search,
        sort,
        paid,
      })
      setTableData(data)
      setTimeout(() => {
        setTableLoader(false)
      }, 200)
    } catch (error) {
      setTableData([])
      setTableLoader(false)
      ErrorMessage(error)
    }
  }

  const handlePageChange = pagNum => {
    setPageNumber(pagNum - 1)
    handleClear()
    callStudentList({ pageNum: pagNum - 1 })
  }

  useEffect(() => {
    const timeout = setTimeout(() => {
      setPageNumber(0)
      callStudentList({ pageNum: 0, search: searchValue })
    }, 1000)
    return () => {
      clearTimeout(timeout)
    }
  }, [searchValue])

  const handleSearch = e => {
    setSearchValue(e.target.value)
  }

  const handleSorting = (pagination, filter, sorter) => {
    setSorter(sorter)
    callStudentList({ sort: sorter })
  }
  let checkData
  const onData = (selectedRowKeys, selectedRows) => {
    setSelectedCandidateId(selectedRowKeys)
    setSelectedCandidate(selectedRows)
    if (tableData?.totalPage > 1 && checkData === undefined) {
      setWholeSelect(false)
    }
  }

  const handleRowSelection = {
    selectedRowKeys: selectedCandidateId,
    onChange: (selectedRowKeys, selectedRows) => {
      onData(selectedRowKeys, selectedRows)
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      setWholeSelect(selected)
      checkData = selectedRows.length
    },
    preserveSelectedRowKeys: true,
  }

  const handleClear = () => {
    setSelectedCandidateId([])
    setSelectedCandidate([])
  }

  const handleConflictPageChange = pageNum => {
    setConflictFilter({ ...conflictFilter, page: pageNum - 1 })
  }

  const handleConflictSearch = e => {
    setConflictFilter({ ...conflictFilter, search: e.target.value })
  }

  const handleStatusClick = async value => {
    try {
      let payLoad = {
        forAllCandidates: isAllSelected,
        studentIds: selectedCandidateId,
        isPaid: value,
        instituteCampusId: instituteCampusId,
        forShowConflicts: false,
      }
      setTableLoader(true)
      const data = await getStatusUpdateBulk(payLoad, params?.eventId)

      if (data?.data?.message == 'Success') {
        setTimeout(() => {
          if (isAllSelected) {
            setPageNumber(0)
          }
          SuccessMessage('Success')
          setIsAllSelected(false)
          setWholeSelect(false)
          callStudentList({})
          getConflict()
          handleClear()
        }, 500)
      } else {
        ErrorMessage('Failed to update status.')
      }
    } catch (error) {
      ErrorMessage(error)
    }
  }

  const menuItem = [
    {
      label: 'XLSX',
      type: 'xlsx',
      image: XlsxImage,
    },
    {
      label: 'Google Sheet',
      type: 'googlesheet',
      image: GoogleSheetImage,
    },
    {
      label: 'CSV',
      type: 'csv',
      image: CsvImage,
    },
  ]
  const exportMenu = (
    <CustomizeMenu>
      {exportLoading ? (
        <Menu.Item key="loading">
          <CustomSpin tip="Loading" size="medium" />
        </Menu.Item>
      ) : (
        <>
          {menuItem.map((item, index) => {
            return (
              <Menu.Item
                key={index + 'menuItem'}
                icon={<img src={item.image} alt="MenuItem" />}
                onClick={() => handleExportClick(item.type)}
              >
                {item.label}
              </Menu.Item>
            )
          })}
        </>
      )}
    </CustomizeMenu>
  )

  const handleExportOpen = () => {
    setExportLoading(false)
    setExportOpen(true)
  }
  const formatTime = time => {
    let timeSplit

    if (moment.isMoment(time)) {
      timeSplit = time.format('HH:mm')
    } else if (typeof time === 'string' && time?.includes(':')) {
      timeSplit = time
    } else {
      console.error('Invalid time format')
      return ''
    }

    const [hour, minute] = timeSplit?.split(':') || []
    const hourNumber = parseInt(hour, 10)
    const period = hourNumber >= 12 ? 'PM' : 'AM'
    const formattedHour = hourNumber % 12 || 12
    return `${formattedHour}:${minute} ${period}`
  }
  return (
    <>
      <PlacementFlex>
        <JobRoleFlex>
          <div>
            <LeftSection centerVertically>
              <CustomDiv onClick={() => navigate(`/events`)}>
                <LeftArrow />
              </CustomDiv>
              <SectionName column disable={true}>
                <BreadCrumb breadCrumbData={breadCrumbData} />
                <BreadLastData>
                  {breadCrumbData[breadCrumbData.length - 1].name}
                </BreadLastData>
              </SectionName>
            </LeftSection>
            <LeftBread>
              {getEventId.startDate?.split('T')[0] ===
              getEventId.endDate?.split('T')[0]
                ? `${dateConversion({
                    date: getEventId?.startDate,
                    convertTo: 'Date/Month/Year',
                  })}`
                : `${dateConversion({
                    date: getEventId?.startDate,
                    convertTo: 'Date/Month/Year',
                  })}
            ${'  -  '}
            ${dateConversion({
              date: getEventId?.endDate,
              convertTo: 'Date/Month/Year',
            })}`}
              <br />
              {getEventId?.allDayEvent
                ? 'All Day'
                : getEventId?.startTime && getEventId?.endTime
                ? `${formatTime(getEventId.startTime)} - ${formatTime(
                    getEventId.endTime
                  )}`
                : ''}
            </LeftBread>
          </div>

          <RightSideDiv>
            <Export
              overlayMenu={exportMenu}
              open={exportOpen}
              setOpen={setExportOpen}
              onOpenChange={handleExportOpen}
              exportLoading={exportLoading}
              label={'Export'}
            />
            {/* <ActionButton
              text={'Export'}
              color="secondary"
              onClick={() => handleTransferClick(true)}
            /> */}
            {getEventId?.registerAmount > 0 && (
              <Button.Secondary
                height={'38px'}
                text={'Bulk Upload'}
                onClick={() => handleBulkUpload()}
              />
            )}
            <Button.Primary
              height={'38px'}
              text={'View Event'}
              onClick={() => handleDrawerClose()}
            />
          </RightSideDiv>
        </JobRoleFlex>

        <StyledTab
          style={{ marginTop: '1.5rem' }}
          onChange={handleTabChange}
          width={'100% !important'}
          activeKey={currentTab}
          defaultActiveKey={currentTab}
        >
          {TabList?.map(data => {
            return (
              <TabPane
                tab={
                  <Fragment>
                    {data?.tabName}
                    <CandidatesSpan>{data?.count}</CandidatesSpan>
                  </Fragment>
                }
                key={data?.key}
              >
                <Table
                  currentTab={currentTab}
                  tableData={tableData}
                  handleResolveConflict={handleResolveConflict}
                  handlePageChange={handlePageChange}
                  pageNumber={pageNumber}
                  tableLoader={tableLoader}
                  searchValue={searchValue}
                  setSearchValue={setSearchValue}
                  handleSearch={handleSearch}
                  handleSorting={handleSorting}
                  handleRowSelection={handleRowSelection}
                  conflictData={conflictData}
                  handleStatusClick={handleStatusClick}
                  selectedCandidateId={selectedCandidateId}
                  isPaid={isPaid}
                  setIsPaid={setIsPaid}
                  selectedCandidate={selectedCandidate}
                  setSelectedCandidate={setSelectedCandidate}
                  setSelectedCandidateId={setSelectedCandidateId}
                  isAllSelected={isAllSelected}
                  setIsAllSelected={setIsAllSelected}
                  wholeSelect={wholeSelect}
                  setWholeSelect={setWholeSelect}
                  getPreview={getPreview}
                  getEventId={getEventId}
                  setPageNumber={setPageNumber}
                />
              </TabPane>
            )
          })}
        </StyledTab>
      </PlacementFlex>
      <Drawer
        width="40%"
        title={'Bulk Upload'}
        placement="right"
        closable={true}
        visible={uploadDrawer}
        content={uploaderContent()}
        footer={file == '' ? false : handleDrawerFooter()}
        onClose={() => {
          setFile('')
          setUploadDrawer(false)
          getConflict()
        }}
      />
      <Drawer
        width="80%"
        title={'Conflicts'}
        placement="right"
        closable={true}
        visible={conflictDrawer}
        content={conflictContent()}
        footer={true}
        onClose={() => {
          setConflictDrawer(false)
          setConflictFilter({
            search: '',
            page: 0,
          })
        }}
      />

      <ExportTransfer
        open={transfer}
        handleClose={handleTransferClick}
        data={data}
        columns={columns}
        targetKeys={targetKeys}
        setTargetKeys={setTargetKeys}
        setSelectedKeys={setSelectedKeys}
        exportType={exportType}
        handleExportType={handleExportType}
        handleExportClick={handleExportClick}
        exportLoading={exportLoading}
        setExportLoading={setExportLoading}
      />

      <PreviewDrawer
        open={isDrawerVisible}
        onClose={handleDrawerClose}
        eventDetails={getEventId}
      />
    </>
  )
}

export default EventRole
